// extracted by mini-css-extract-plugin
module.exports = {"container":"Nw-z","links":"Ow-z"};